/**
 * Shared presentation helpers for onboarding summary generation.
 *
 * The in-chat progress indicator and the summary page both report the same generation,
 * so they read stage/elapsed from here rather than keeping their own copies.
 */

/** Stage-based progress so the bar reflects reality instead of a fixed width. */
export const SUMMARY_STAGE_PROGRESS: Record<string, number> = {
  starting: 15,
  "calling ai": 55,
  calling_ai: 55,
  saving: 85,
  completed: 100,
};

/** Percentage for a backend `current_stage`; unknown stages get a neutral midpoint. */
export const stageProgressPercent = (stage?: string | null): number =>
  SUMMARY_STAGE_PROGRESS[stage ?? ""] ?? 40;

/** "calling_ai" → "calling ai" */
export const humanizeStage = (stage?: string | null): string => (stage ? stage.replace(/_/g, " ") : "");

export const formatElapsedTime = (seconds?: number | null): string => {
  if (!seconds) return "";
  if (seconds < 60) return `${Math.floor(seconds)}s`;
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes}m ${remainingSeconds}s`;
};

/** Generation has clearly overrun and an interrupt is worth offering. */
export const SUMMARY_OVERRUN_SECONDS = 120;

// Stall detection lives in `sessionAdapter.isSummaryStalled` — it deliberately
// ignores `is_task_running` (that flag is web-process-local and blind to queued
// TaskIQ work), so don't re-add a check for it here.
